import moment from "moment";

export {
  sortDateTime,
  sortBasic,
  sortElementProperty,
  sortFavorite,
  sortLink,
  sortMulti,
};

import { SortByFn } from "react-table";

import {
  SortResult,
  SignFn,
  SortFn,
  WrappedSortFn,
  SortWrapperFn,
} from "@/@types/ui/Table";

const sortDateTime: SortByFn<any> = (rowA, rowB, columnId) => {
  const momA = moment(rowA.original[columnId]);
  const momB = moment(rowB.original[columnId]);

  if (!momA.isValid() && !momB.isValid()) return 0;
  if (!momA.isValid()) return 1;
  if (!momB.isValid()) return -1;

  if (momA.isBefore(momB)) return -1;
  if (momA.isAfter(momB)) return 1;
  return 0;
};
const sortBasic: SortByFn<any> = (rowA, rowB, columnId) => {
  const valA = rowA.original[columnId];
  const valB = rowB.original[columnId];

  const isEmpty = (val: any) => val === null || val === undefined || val === "";

  if (isEmpty(valA) && isEmpty(valB)) return 0;
  if (isEmpty(valA)) return 1;
  if (isEmpty(valB)) return -1;

  if (typeof valA === "number" && typeof valB === "number") {
    return valA - valB;
  }

  if (typeof valA === "string" && typeof valB === "string") {
    const a = valA.toUpperCase();
    const b = valB.toUpperCase();
    if (a > b) return 1;
    if (a < b) return -1;
    return 0;
  }

  if (typeof valA === "boolean" && typeof valB === "boolean") {
    if (valA === valB) {
      return 0;
    } else if (valA) {
      return 1;
    } else {
      return -1;
    }
  }

  return 0;
};
const sortElementProperty: SortFn = (rowA, rowB, columnId, desc) =>
  sortWrapper(wrappedSortElementProperty, rowA, rowB, columnId, desc);
const sortFavorite: SortFn = (rowA, rowB, columnId, desc) =>
  sortWrapper(wrappedSortFavorite, rowA, rowB, columnId, desc);
const sortLink: SortFn = (rowA, rowB, columnId, desc) =>
  sortWrapper(wrappedSortLink, rowA, rowB, columnId, desc);
const sortMulti: SortFn = (rowA, rowB, columnId, desc) =>
  sortWrapper(wrappedSortMulti, rowA, rowB, columnId, desc);

const signFn: SignFn = (n: number) => (n === 0 ? 0 : n > 0 ? 1 : -1);

const sortWrapper: SortWrapperFn = (fn, rowA, rowB, columnId, desc) => {
  const res = fn(rowA, rowB, columnId);
  return signFn(desc ? -1 * res : res);
};

const wrappedSortElementProperty: WrappedSortFn = (rowA, rowB, columnId) => {
  const valA = rowA.values[columnId]
    ? rowA.values[columnId].props.property
    : null;
  const valB = rowB.values[columnId]
    ? rowB.values[columnId].props.property
    : null;

  return Number(valB) - Number(valA);
};

const wrappedSortFavorite: WrappedSortFn = (rowA, rowB, columnId) => {
  // By design they both must have props.value otherwise this will crash
  const valA = rowA.values[columnId] ? rowA.values[columnId].props.value : null;
  const valB = rowB.values[columnId] ? rowB.values[columnId].props.value : null;

  // Number(false) = 0, Number(true) = 1
  // a - b (difference) -> sorts elements in ascending order, since we want descending (true before false or 1 before 0) we do it the other way around
  return Number(valB) - Number(valA);
};

const wrappedSortLink: WrappedSortFn = (rowA, rowB, columnId) => {
  // By design they both must have props.value otherwise this will crash
  const valA = rowA.values[columnId] ? rowA.values[columnId].props.value : null;
  const valB = rowB.values[columnId] ? rowB.values[columnId].props.value : null;

  // Number(false) = 0, Number(true) = 1
  // a - b (difference) -> sorts elements in ascending order, since we want descending (true before false or 1 before 0) we do it the other way around
  return valA.toUpperCase() > valB.toUpperCase() ? 1 : -1;
};

const wrappedSortMulti: WrappedSortFn = (rowA, rowB, columnId) => {
  const valA = rowA.values[columnId]
    ? rowA.values[columnId].props.property.length
    : null;
  const valB = rowB.values[columnId]
    ? rowB.values[columnId].props.property.length
    : null;

  return Number(valB) - Number(valA);
};
